/* RESPONSIBLE TEAM: team-phone */
import VoicemailUpSerializer from '../step';

export default VoicemailUpSerializer;
